import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import { PageTemplate } from "../common/PageTemplate";
import DataGrid from '../../OurModules/DataGrid/src/index.js';
import moment from 'moment-timezone';
import * as FileSaver from 'file-saver';

/**
 * Container component for the Authorizations page.
 * 
 */
class Authorizations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: true,
            authorizationsList: [],
            shouldRetrieveData: true,
            dateRange: localStorage.getItem('authorizationsDateRange')
                ? JSON.parse(localStorage.getItem('authorizationsDateRange'))
                : { from: moment().subtract(1, "months").format("MM/DD/YYYY"), to: moment().format("MM/DD/YYYY") }
        };
        this.goToDetails = this.goToDetails.bind(this);
        this.addAuthStatusCSSClass = this.addAuthStatusCSSClass.bind(this);
        this.assignAuthStatusCSSClass = this.assignAuthStatusCSSClass.bind(this);
        this.addFirstNameProp = this.addFirstNameProp.bind(this);
        this.addApprovalLetter = this.addApprovalLetter.bind(this);
        this.queueApprovalLetterDownload = this.queueApprovalLetterDownload.bind(this);
        this.getAuthorizationsList = this.getAuthorizationsList.bind(this);
        this.dateChanged = this.dateChanged.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.AuthorizationsList.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;
        if (this.props.authorizationsList !== prevProps.authorizationsList) {
            if (this.props.authorizationsList) {
                let authorizations = this.props.authorizationsList;
                authorizations = this.addAuthStatusCSSClass(authorizations);
                authorizations = this.addApprovalLetter(authorizations);
                authorizations = this.addFirstNameProp(authorizations);
                this.setState({ authorizationsList: authorizations && authorizations.length > 0 ? authorizations : [], showLoader: false });
            }
        }
        if ((this.props.approvalLetter !== prevProps.approvalLetter || this.props.error !== prevProps.error) && this.props.authorizationsList) {
            this.handleApprovalLetterDownload();
        }
        if ((swhp || hpIdentity) && this.state.shouldRetrieveData && !isFetching) {
            this.setState({ shouldRetrieveData: false });
            this.getAuthorizationsList();
        }

    }

    getAuthorizationsList() {
        let from, to;
        from = moment(this.state.dateRange.from).format("MM/DD/YYYY");
        to = moment(this.state.dateRange.to).format("MM/DD/YYYY");
        this.setState({ showLoader: true }, () => this.props.getAuthorizations(from, to));
    }

    goToDetails(e) {
        this.props.history.push(`/authorizationdetail`, { authorizationHccId: e.authorizationHccId });
    }

    addAuthStatusCSSClass(authorizations) {
        if (!authorizations || !authorizations.length) {
            return authorizations;
        } else {
        authorizations.map((authorization) => {
            authorization.approvalLetterAvailableClass = authorization.documentIsAvailable ? "" : "hide-link-styling";
            return authorization.statusClass = this.assignAuthStatusCSSClass(authorization.authorizationStatusName);
        });
        return authorizations;
        }
    }

    assignAuthStatusCSSClass(status) {
        switch (status.toUpperCase()) {
            case "APPROVED":
                return "authorization-approved";
            case "PARTIALLY APPROVED":
                return "authorization-partially-approved";
            case "PENDING":
                return "authorization-pending";
            case "NOT APPROVED":
                return "authorization-not-approved";
            default:
                return "";
        }
    }

    addApprovalLetter(authorizations) {
        if (!authorizations || authorizations.length === 0) {
            return authorizations;
        }
        authorizations.map((authorization) => {
            authorization.approvalLetter = authorization.documentIsAvailable ? "Download" : "Unavailable";
            return authorization;
        });
        return authorizations;
    }

    addFirstNameProp(authorizations) {
        if (!authorizations || authorizations.length === 0) {
            return authorizations;
        }
        authorizations.map((authorization) => {
            if (authorization.patientName) {
                //assuming "lastname, firstname" format, which is how it's returned from HR 
                const names = authorization.patientName.trim().split(',');
                const fName = names[1].trim().split(' '); //just in case there's a middle initial, exclude it
                return authorization.firstName = fName[0];
            }
            else {
                return authorization.firstName = "";
            }

        });
        return authorizations;
    }

    queueApprovalLetterDownload(data) {
        if (data.documentIsAvailable && data.authorizationHccId) {
            this.props.getAuthorizationApprovalLetter(data.authorizationHccId);
        }
        else {
            console.log('approval letter unavailable');
        }
    }

    handleApprovalLetterDownload() {
        if (this.props.error || !this.props.approvalLetter || this.props.approvalLetter.status === 204) {
            return;
        }

        FileSaver.saveAs(this.props.approvalLetter, "Approval Letter.pdf");
    }

    dateChanged(filterType, data) {
        if (filterType === "date") {
            console.log("setting authorizatons date range in localStorage");
            const fromDate = moment(data.dateRange.from).format("MM/DD/YYYY");
            const toDate = moment(data.dateRange.to).format("MM/DD/YYYY");
            const dateRangeObj = {
                from: fromDate,
                to: toDate,
                expire: "ONLOGOUT"
            }
            localStorage.setItem("authorizationsDateRange", JSON.stringify(dateRangeObj));
            this.setState({ dateRange: data.dateRange }, () => this.getAuthorizationsList());
        }
    }

    render() {
        var columnMetadata = [
            {
                type: "date",
                title: "Date",
                value: "startDate",
                allowSorting: true
            },
            {
                type: "string",
                title: "Member",
                value: "firstName",
                allowSorting: true
            },
            {
                type: "string",
                title: "Referrer",
                value: "referringProviderName",
                allowSorting: true
            },
            {
                type: "string",
                title: "Auth Number",
                value: "authorizationHccId",
                allowSorting: true,
                hideOnTablet: true
            },
            {
                type: "string",
                title: "Alt Number",
                value: "externalAuthorizationNum",
                allowSorting: true,
                excludeFromExport: true
            },
            {
                type: "string",
                title: "Auth Type",
                value: "authorizationType",
                allowSorting: true
            },
            {
                type: "string",
                title: "Admit Type",
                value: "admissionType",
                allowSorting: true
            },
            {
                type: "string",
                title: "Approval Letter",
                value: "approvalLetter",
                allowSorting: true,
                hideOnTablet: true,
                clickCallback: this.queueApprovalLetterDownload,
                customCSSMapToValue: "approvalLetterAvailableClass",
                excludeFromExport: true
            },
            {
                type: "string",
                title: "Status",
                value: "authorizationStatusName",
                allowSorting: true,
                customCSSMapToValue: "statusClass"
            },
        ]
        var gridMetadata = {
            title: "",
            selectable: true,
            enableFilters: true,
            filters: [{ filterName: "Member", dataKeyToUse: "firstName" }, { filterName: "Referrer", dataKeyToUse: "referringProviderName" }, { filterName: "Auth Type", dataKeyToUse: "authorizationType" }],
            initialDate: this.state.dateRange,
            searchFields: ["authorizationHccId", "authorizationType", "referringProviderName"],
            searchPlaceholder: "Search by authorization number, type, or referrer",
            dateField: "startDate",
            enableExport: true,
            enableSearch: true,
            enableDateRange: true, //not implemented
            exportFormats: ["xls", "pdf"],
            exportName: "Authorizations",
            sortingEnabled: true,
            pagination: false, //not implemented
            rowsPerPage: 10, //not implemented
            rowClick: this.goToDetails,
            filterCallback: this.dateChanged,
            stopDateFilterPropogation: true, //stops date filtering and only runs specified callback, useful for making api calls that filter date
            columns: columnMetadata
        }
        return (
             <PageTemplate objectName='authorizations' pageTitle='Authorizations' >
                <DataGrid id="authorizations-data-grid" dataSource={this.state.authorizationsList} gridOptions={gridMetadata} showLoader={this.state.showLoader}></DataGrid>
             </PageTemplate>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authorizationsList: state.healthPlanServices.authorizations,
        approvalLetter: state.healthPlanServices.authorizationApprovalLetter,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        isFetching: state.healthPlanServices.isFetching,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAuthorizations: (startDate, endDate) => dispatch({ type: types.HP_GET_AUTHORIZATIONS_LIST_START, startDate: startDate, endDate: endDate  }),
        getAuthorizationApprovalLetter: (authorizationHccId) => dispatch({ type: types.HP_GET_AUTHORIZATION_APPROVAL_LETTER_START, authorizationHccId: authorizationHccId })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authorizations));
